import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import LinkedVendors from '../../models/LinkedVendors'

export interface LinkedVendorsListState extends PaginatedApiState {
  linkedVendors?: LinkedVendors[]
}

const VendorList = (state: LinkedVendorsListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<LinkedVendorsListState>('LINKED_VENDORS_LIST')(state, action)
  }
}

export default VendorList
